import axios from 'axios';
import BaseAPI from './base/base-api';

class SupplierAcceptTaxAuthorityAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'supplieraccept';
}

export default new SupplierAcceptTaxAuthorityAPI();